export { default as Skeleton } from './Skeleton';
export type { ISkeletonProps } from './types';
